import React, { useState, useEffect } from "react";
import GridContainer from "../../components/Grid/GridContainer";
import Consent from "./Consent";
import { getStyleForConsentLayout } from "../styles/commonStyles";
import { useTheme, Box } from "@mui/material";
import { commonBackgroundImageHelper } from "../public/CommonAPIHelper";
import Loader from "../public/Loader";
const defaultLogo = require("../../assets/images/logo.png");

const ConsentLayout = (props) => {
  const organizationId = localStorage.getItem("organizationId");
  const careCenterId = localStorage.getItem("careCenterId");
  const [imageSrc, setImageSrc] = useState();
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [backgroundImage, setBackgroundImage] = useState();
  const [mobileBackgroundImage, setMobileBackgroundImage] = useState();
  const classes = getStyleForConsentLayout(
    theme,
    backgroundImage,
    mobileBackgroundImage
  );
  useEffect(() => {
    (async () => {
      await commonBackgroundImageHelper(
        organizationId,
        careCenterId,
        setLoading,
        setBackgroundImage,
        setMobileBackgroundImage,
        setImageSrc
      );
    })();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box component="div" key="en" sx={classes.bgSet}>
          <div>
            <GridContainer justifyContent="center">
              <Box component="div" sx={classes.cardWidth}>
                <Box component="div" sx={classes.textCenter}>
                  <Box
                    component="img"
                    alt=""
                    src={imageSrc}
                    sx={classes.logoSize}
                    onError={() => setImageSrc(defaultLogo)}
                  />
                </Box>
                <Consent loading={loading} setLoading={setLoading} {...props} />
              </Box>
            </GridContainer>
          </div>
        </Box>
      )}
    </>
  );
};
export default ConsentLayout;
